// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_wrapper__95rMx","content":"wrapper_content__a7gzx"};